export default __webpack_public_path__ + "static/media/icons-project-dashboard.3df6b28f.svg";